/* eslint-disable */

import { rootApi } from '../rootApi';

export const dealerAddressBrandProfitApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerAddressProfit: builder.query({
            query: ({ dealerAddressBrandId, pageNumber = 1, pageSize = 10 }) => {
                const params = {
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    DealerAddressBrandId: dealerAddressBrandId
                };
                return {
                    url: 'v1/dealeraddressprofit/get', // ✅ brand yok → Swagger ile aynı
                    method: 'GET',
                    params
                };
            },
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        count: response.data.totalCount || 0
                    };
                }
                return {
                    items: [],
                    count: 0
                };
            },
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 dealeraddressprofit/get query started with:', arg);
                try {
                    const result = await queryFulfilled;
                    console.log('✅ dealeraddressprofit/get query fulfilled:', result);
                } catch (error) {
                    console.error('❌ dealeraddressprofit/get query failed:', error);
                }
            },
            providesTags: ['DealerAddressProfit']
        }),

        getByIdDealerAddressProfit: builder.query({
            query: (id) => {
                return {
                    url: 'v1/dealeraddressprofit/getbyid',
                    method: 'GET',
                    params: {
                        id: id
                    }
                };
            },

            transformResponse: (response) => {
                if (response && typeof response === 'object' && response.data) {
                    return response.data;
                }
                return {};
            },

            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {
                    console.error('❌ dealeraddressbrandprofit/getbyid query failed:', error);
                }
            },
            providesTags: (result, error, id) => [{ type: 'DealerAddressBrandProfit', id }]
        }),

        createDealerAddressProfit: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressprofit/post',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandProfit', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        updateDealerAddressProfit: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/dealeraddressprofit/update',
                    method: 'PUT',
                    body: data
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandProfit', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        })
    })
});

export const { useGetAllDealerAddressProfitQuery, useCreateDealerAddressProfitMutation, useUpdateDealerAddressProfitMutation, useGetByIdDealerAddressProfitQuery } = dealerAddressBrandProfitApi;
